export const blueGradientButton = {
  padding: '12px 16px',
  gap: '8px',
  color: 'black',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '6px',
    padding: '2px', //ajust the padding to change the width of the border radius
    background: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
  },
  '&:hover': {
    backgroundImage: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
    color: 'white',
  },
};

export const blueGradientRoundButton = {
  color:'black',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '100px',
    padding: '2px', //ajust the padding to change the width of the border radius
    background: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
  },
  '&:hover': {
    backgroundImage: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
    borderRadius: '100px',
    color:'white',
  },
};